// extracted by mini-css-extract-plugin
export default {"indicators":"carousel_indicators__AC3V0","wrapper":"carousel_wrapper__2E4uX","status":"carousel_status__wB7y6"};